/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// Tailbase

// Helpers
function debounce(func, waitFor = 500) {
  var timeout;
  return function () {
    var context = this;
    var args = arguments;
    var later = function () {
      timeout = null;
      func.apply(context, args)
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, waitFor);
  };
}

// Product Detail Page
if (window.theme.pageType === 'product') {

  function hideElement(element, display = "block") {
    var elDisplay = window.getComputedStyle(element).display;
    if (elDisplay === display) {
      element.style.display = "none";
    }
  }
  // Toggle Functions
  function toggleElement(element, display = "block") {
    var elDisplay = window.getComputedStyle(element).display;
    if (elDisplay === "none") {
      element.style.display = display;
    } else {
      element.style.display = "none";
    }
  }

  function toggleElementText(element, hideText, showText) {
    if (hideText && showText) {
      if (element.innerHTML === hideText) {
        element.innerHTML = showText;
      } else {
        element.innerHTML = hideText;
      }
    }
  }


  // Product Detail Page
  // View more Button
  var viewMoreBtn = document.getElementsByClassName('product-form__rebate-view-more-btn');
  var truncatedText = document.getElementsByClassName('product-meta__truncated-description');
  var completeText = document.getElementsByClassName('product-meta__complete-text');

  function viewDescriptionBehavior() {
    if (viewMoreBtn.length > 0 && truncatedText.length > 0 && completeText.length > 0) {
      toggleElement(truncatedText[0], 'inline');
      toggleElement(completeText[0], 'inline');
      toggleElementText(viewMoreBtn[0], window.languages.viewMore, window.languages.viewLess);

      var productInfoElement = document.querySelector('.product-block-list__item--info .card');

      if (productInfoElement) {
        document.querySelector('.product-block-list__wrapper').style.minHeight = "".concat(productInfoElement.clientHeight, "px");
      }
    }

  }

  if (viewMoreBtn.length > 0 && truncatedText.length > 0 && completeText.length > 0) {
    viewMoreBtn[0].addEventListener('click', function () {
      viewDescriptionBehavior();
    });

    viewMoreBtn[0].addEventListener('keyup', function (event) {
      if (event.keyCode === 13) {
        viewDescriptionBehavior();
      }
    });
  }


  // Rebate Lean More Toggle
  // Add onresize debounce function
  var rebateLearnMore = document.getElementsByClassName('product-form__rebate-learn');
  var rebateInfo = document.getElementsByClassName('product-form__rebate-info');
  var rebates = document.getElementsByClassName('product-form__rebates');
  var warehouseBody = document.getElementsByClassName('warehouse--v1');

  function handleDesktopLearnMoreClick(e) {
    toggleElement(rebateInfo[0]);
    e.stopPropagation();
  }

  function handleMobileLearnMoreClick() {
    scrollToWithOffSet(rebates[0], 100)
  }

  function handleRebateInfoClick(e) {
    e.stopPropagation();
  }

  function handleBodyClick() {
    hideElement(rebateInfo[0]);
  }

  function rebateBehavior() {
    if (rebateLearnMore.length > 0 && rebateInfo.length > 0 && warehouseBody.length > 0 && rebates.length > 0) {
      var isDesktop = window.matchMedia('screen and (min-width: 1000px)').matches;
      var isMobile = window.matchMedia('screen and (max-width: 999px)').matches;

      if (isDesktop) {
        rebateLearnMore[0].removeEventListener('click', handleMobileLearnMoreClick);
        warehouseBody[0].addEventListener('click', handleBodyClick)
        rebateLearnMore[0].addEventListener('click', handleDesktopLearnMoreClick);
        rebateInfo[0].addEventListener('click', handleRebateInfoClick);
        rebateLearnMore[0].addEventListener('keyup', function(event) {
          if (event.keyCode === 13) {
            handleDesktopLearnMoreClick()
          }
        });

      }
      if (isMobile) {
        rebateLearnMore[0].removeEventListener('click', handleDesktopLearnMoreClick);
        rebateInfo[0].removeEventListener('click', handleRebateInfoClick);
        rebateLearnMore[0].addEventListener('click', handleMobileLearnMoreClick);
        rebateLearnMore[0].addEventListener('keyup', function(event) {
          if (event.keyCode === 13) {
            handleMobileLearnMoreClick()
          }
        });
      }
    }
  }

  var debouncedRebateBehavior = debounce(rebateBehavior)

  window.addEventListener('resize', debouncedRebateBehavior)
  window.addEventListener('load', rebateBehavior)

  // Tabs
  var productTabsSection = document.getElementById("product-tabs-section");
  if (productTabsSection) {
    var productTabsoptions = JSON.parse(productTabsSection.getAttribute('data-section-settings'));
  
    var productTabsMenu = document.getElementsByClassName('product_tabs__titles');
    var header = document.getElementById("shopify-section-header");
  
    if (productTabsMenu.length > 0 && header) {
      var productTabsMenuOffsetTop = getTopPosition(productTabsMenu[0])
      window.addEventListener('scroll', function (e) {
        if (this.window.innerWidth > 999) {
          if (window.pageYOffset > (productTabsMenuOffsetTop - 200)) {
            header.classList.add("hide-header-desktop")
            productTabsMenu[0].classList.add("tabs-titles-sticky")
            if (rebateInfo.length > 0) {
              rebateInfo[0].style.display = 'none'
            }
          } else if (header.style.opacity == 0) {
            header.classList.remove("hide-header-desktop")
            productTabsMenu[0].classList.remove("tabs-titles-sticky")
          }
        }
      });
    }
  
    var featuresLink = document.getElementById("features-title");
    var featuresContent = document.getElementById("product-features");
  
    var specsLink = document.getElementById("specs-title");
    var specsContent = document.getElementById("product-specs");
  
    var documentsLink = document.getElementById("documents-title");
    var documentsContent = document.getElementById("product-documents");
  
    var associatedProductsLink = document.getElementById("associated-products-title");
    var associatedProductsContent = document.getElementById("product-associated-products");
  
    var backToProductInfoMenuBtn = document.getElementsByClassName("product_tabs__menu-btn");
    var productInfoMenu = document.getElementById("product-info-menu");

  
    if (featuresLink && featuresContent) scrollToWithOffSetListener(featuresLink, featuresContent, productTabsoptions.defaultOffset);
    if (specsLink && specsContent) scrollToWithOffSetListener(specsLink, specsContent, productTabsoptions.defaultOffset);
    if (documentsLink && documentsContent) scrollToWithOffSetListener(documentsLink, documentsContent, productTabsoptions.defaultOffset);
    if (associatedProductsLink && associatedProductsContent) scrollToWithOffSetListener(associatedProductsLink, associatedProductsContent, productTabsoptions.defaultOffset);
  
    if (backToProductInfoMenuBtn.length > 0 && productInfoMenu) {
      for (var i = 0; i < backToProductInfoMenuBtn.length; i++) {
        scrollToWithOffSetListener(backToProductInfoMenuBtn.item(i), productInfoMenu, productTabsoptions.defaultOffset)
      }
    }
  }
 

  function scrollToWithOffSetListener(link, content, offset) {
    link.addEventListener('click', function () {
      scrollToWithOffSet(content, offset);
    });
    link.addEventListener('keyup', function (event) {
      if (event.keyCode === 13) {
        scrollToWithOffSet(content, offset);
      }
    });
  }

  function scrollToWithOffSet(content, offset) {
    window.scrollTo({
      top: getTopPosition(content) - offset,
      behavior: 'smooth'
    });
  }

  function getTopPosition(content) {
    var rect = content.getBoundingClientRect()
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return rect.top + scrollTop;
  }

  // Buy It Now

  const productForm = document.querySelector('form[action*="/cart/add"]');
  const newAction = productForm.action.replace("/add", "");
  if (productForm) {
    const validateInstallationProducts = document.getElementsByClassName('installation product-form__validate-products');
    const validateWarrantyProducts = document.getElementsByClassName('warranty product-form__validate-products');
    const isInstallationValidating = validateInstallationProducts.length > 0;
    const isWarrantyValidating = validateWarrantyProducts.length > 0;
    let installationInputHasChanged = false;
    let warrantyInputHasChanged = false;
    let isInstallationValidated = false
    let isWarrantyValidated = false
    if (isInstallationValidating) {
      const installationInputs = document.getElementsByClassName('installation add-to-cart-product__checkbox');
      Array.from(installationInputs).forEach((input) => {
        input.addEventListener('change', () => {
          handleNoneForCheckbox(input, installationInputs);
          installationInputHasChanged = true;
        });
      });
    }
    if (isWarrantyValidating) {
      const warrantyInputs = document.getElementsByClassName('warranty add-to-cart-product__checkbox');
      Array.from(warrantyInputs).forEach((input) => {
        input.addEventListener('change', () => {
          handleNoneForCheckbox(input, warrantyInputs);
          warrantyInputHasChanged = true;
        });
      });
    }
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (isInstallationValidating || isWarrantyValidating) {
        if (isInstallationValidating && !isInstallationValidated && !installationInputHasChanged) {
          displayValidationMessage(validateInstallationProducts);
          isInstallationValidated = true;
          if (!isWarrantyValidating || warrantyInputHasChanged) return;
        }
        if (isWarrantyValidating && !isWarrantyValidated && !warrantyInputHasChanged) {
          displayValidationMessage(validateWarrantyProducts)
          isWarrantyValidated = true;
          return;
        }
      }
      
      // Check if some Buy It Now products are checke
      var checkboxes = document.getElementsByClassName("add-to-cart-product__checkbox");
      var addToCartProducts = [];

      for (checkbox of checkboxes) {
        if (checkbox.checked && checkbox.getAttribute("data-variant")) {
          var productToAdd = {
            id: checkbox.getAttribute("data-variant"),
            quantity: '1'
          };
          addToCartProducts.push(productToAdd)
        }
      }

      let formData = new FormData(productForm);
      var products = [...addToCartProducts, { id: formData.get("id"), quantity: formData.get("quantity") }];
      fetch('/cart/add.js', {
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: products }),
        method: 'POST'
      })
        .then(response => {
          location.href = newAction;
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });


    function displayValidationMessage(elements) {
      Array.from(elements).forEach((element) => {
        element.style.display = 'block';
      });
    }
  
    function handleNoneForCheckbox(input, elements) {
      if (input.hasAttribute("none") && input.classList.contains("checkbox")) {
        removeAllButNone(elements)
      } else if(input.classList.contains("checkbox")) {
        removeNone(elements)
      }
    }
  
    function removeNone(parentEl) {
      Array.from(parentEl).forEach((input) => {
        if (input.hasAttribute("none")) {
          input.checked = false
        }
      });
    }
  
    function removeAllButNone(parentEl) {
      Array.from(parentEl).forEach((input) => {
        if (!input.hasAttribute("none")) {
          input.checked = false
        }
      });
    }
  }

  

  // Syndigo
  const p = document.querySelector('syndigo-powerpage')
  if (p) {
    p.addEventListener('content', function (ev) {
      if (!ev.detail.hasContent) {
        p.remove();
      }
    })
  }

  // loadbee
  window.onload = () => {
    // displaying the loadbee Manufacturer Info if there is some content
    var loadbeeContainer = document.querySelector('#product-manufacturer-loadbee');
    if (loadbeeContainer) {
      setTimeout(() => {
        if (loadbeeContainer.querySelector('.loadbeeTabContent').children.length > 0)
          loadbeeContainer.style.display = 'block';
      }, 1000);
    }
  };

}

